<template>
  <a-card :bordered="false">
    <a-form layout="inline">
      <a-form-item>
        <a-input v-model="queryParams.title" placeholder="通知标题"></a-input>
      </a-form-item>
      <a-form-item>
        <a-select v-model="queryParams.noticetype" style="width: 174px;" :allowClear="true" placeholder="通知方式">
          <a-select-option :value="1">站内信</a-select-option>
          <a-select-option :value="2">模板通知</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-select v-model="queryParams.channeltype" style="width: 174px;" :allowClear="true" placeholder="通知终端">
          <a-select-option :value="1">小程序</a-select-option>
          <a-select-option :value="2">公众号</a-select-option>
          <a-select-option :value="3">H5商城</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
      </a-form-item>
    </a-form>
    <div style="margin: 20px 0;">
      <a-button type="primary" @click="promotebtn">推广设置</a-button>
      <a-button @click="msgVisible = true" type="primary" style="margin-left: 30px;">群发通知</a-button>
    </div>
    <custom-page-table
      style="margin-top: 16px;"
      ref="table"
      :queryParams="queryParams"
      :columns="columns"
      base-key="serviceUrl"
      query-path="inform/getInformLog"
    >
    </custom-page-table>
    <a-modal title="推广设置" :width="900" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="推广文案">
          <a-input v-model="promote.treatment" placeholder="最多30个字" :maxLength="30"></a-input>
        </a-form-model-item>
        <a-form-model-item label="关联商品">
          <!-- <a-button type="primary" size="small" @click="openproductmodal">选择</a-button> -->
          <a-button type="primary" @click="openproductmodal" style="margin-right: 10px">选择</a-button>
          <span v-if="promote.productdetail">{{ promote.productdetail }}</span>
          <span v-if="promote.proName">{{ promote.proName }}</span>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 12, offset: 5 }">
          <a-radio-group v-model="promote.treatmentStatus">
            <a-radio :value="0">开启</a-radio>
            <a-radio :value="1">关闭</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-button type="primary" @click="savesetbtn" style="margin-right: 10px"
          >保存设置
          </a-button
          >
          <span>*保存后微信模板消息推送中将展示该信息</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal title="商品选择" :width="900" :footer="null" :visible="productVisible" @cancel="productCancel">
      <a-form layout="inline">
        <a-form-item label="商品ID">
          <a-input v-model="queryProduct.proId" placeholder="请输入商品ID"></a-input>
        </a-form-item>
        <a-form-item label="商品名称">
          <a-input v-model="queryProduct.proName" placeholder="请输入商品名称"></a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="$refs.productTable.refresh(true)">查询</a-button>
        </a-form-item>
      </a-form>
      <custom-page-table
        style="margin-top: 16px;"
        ref="productTable"
        :queryParams="queryProduct"
        :columns="columnsProduct"
        base-key="proUrl"
        params-path="public/getGoodsList"
      >
        <span slot="index" slot-scope="rowItem">
          {{ rowItem.index + 1 }}
        </span>
        <span slot="action" slot-scope="rowItem">
          <a @click="selectProduct(rowItem.record)">选择</a>
        </span>
      </custom-page-table>
    </a-modal>
    <a-modal title="群发通知" :width="900" :footer="null" :visible="msgVisible" @cancel="msgCancel">
      <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="站内信" :required="true">
          <a-row :gutter="8">
            <a-col :span="16">
              <a-input v-model="form.title" placeholder="标题8个字以内" :maxLength="8"></a-input>
            </a-col>
          </a-row>
          <a-row style="margin-top: 10px;" :gutter="8">
            <a-col :span="4">
              <a-upload
                class="avatar-uploader"
                list-type="picture-card"
                :showUploadList="false"
                :action="actionImageUrl"
                :before-upload="beforeUpload"
                @change="handleChange"
              >
                <img v-if="imageUrl3" :src="imageUrl3" class="avatar"/>
                <a-icon v-else type="plus"/>
              </a-upload>
            </a-col>
            <a-col :span="12" style="padding-left:20px">
              <a-input v-model="form.descript" placeholder="简介描述30个字以内" :maxLength="30"></a-input>
              <a-textarea
                style="margin-top: 10px;"
                :rows="2"
                v-model="form.activity"
                placeholder="来自官方活动"
              ></a-textarea>
            </a-col>
          </a-row>
        </a-form-model-item>
        <a-form-model-item label="关联商品" :required="true">
          <a-button type="primary" @click="openproductmodal">选择</a-button>
          <span v-if="form.productdetail">{{ form.productdetail }}</span>
        </a-form-model-item>
        <a-form-model-item label="接收人" :required="true">
          <a-radio-group v-model="form.type">
            <a-radio :value="1">用户</a-radio>
            <a-radio :value="2">商户</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="发送范围" :required="true">
          <a-radio-group v-model="form.scopeof">
            <a-radio :value="1">全部发送</a-radio>
            <a-radio :value="2">指定发送</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="form.scopeof == 2" label="接收手机号" extra="只能上传excel文件，且不超过10M">
          <a-row>
            <a-col :span="16">
              <a-textarea
                :disabled="fileList.length > 0"
                :rows="2"
                v-model="form.phones"
                placeholder="手机号一行一个"
              ></a-textarea>
            </a-col>
          </a-row>
          <div style="margin-top: 10px;">
            <a-upload
              :file-list="fileList"
              @change="handleChangeFile"
              :multiple="false"
              :before-upload="beforeUploadFile"
            >
              <a-button type="primary">选取附件</a-button>
              <a-button icon="download" style="margin-left: 20px;" @click="downloadTemplateFile()"
              >下载手机号模板
              </a-button
              >
            </a-upload>
          </div>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 12, offset: 3 }">
          <a-button type="primary" @click="sendbtn">确认发送</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'MessageNotificationList',
  data() {
    return {
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      actionImageUrl: this.getAppConfig().baseUrl + 'base/upload',
      imageUrl3: '',
      labelCol: { span: 5 },
      wrapperCol: { span: 17 },
      columns: [
        {
          title: '通知标题',
          dataIndex: 'templateTitle'
        },
        {
          title: '通知方式',
          dataIndex: 'templateTouch'
        },
        {
          title: '通知终端',
          dataIndex: 'templateTerminal'
        },
        {
          title: '接收人',
          dataIndex: 'recMobile'
        },
        {
          title: '推广文案',
          dataIndex: 'treatment',
          width: '15%'
        },
        {
          title: '跳转链接/页面路径',
          dataIndex: 'treatmentUrl',
          width: '25%'
        },
        {
          title: '通知时间',
          dataIndex: 'sendTime'
        }
      ],
      columnsProduct: [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '50%'
        },
        {
          title: '商品分类',
          dataIndex: 'proCatalogId'
        },
        {
          title: '地区',
          dataIndex: 'departure'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      uploadFileUrl: '',
      queryProduct: {},
      formtype: 1,
      visible: false,
      fileList: [],
      promote: {
        id: '', // 推广文案id
        proId: '',
        activity: '', // 活动
        title: '', // 推广文案
        type: '', // 推广按钮 开启或者保存
        productdetail: '', // 推广商品详情
        proCityName: '', // 选择商品城市
        proCatalogId: '', // 选择商品分类id
        proNo: '', // 选择商品编号
        proProvinceName: '', // 选择商品省份
        proCatalogName: '' // 选择商品分类名字
      },
      form: {
        proId: '',
        type: 1, // 发送接受者类型
        title: '', // 站内信标题
        productdetail: '', // 站内信商品信息
        proCityName: '', // 选择商品城市
        proCatalogId: '', // 选择商品分类id
        proNo: '', // 选择商品编号
        proProvinceName: '', // 选择商品省份
        proCatalogName: '', // 选择商品分类名字
        descript: '', // 描述
        scopeof: 1, // 发送种类
        phones: '', // 手机号
        activity: '',//来源
        platformId: this.getPlatformConfig().platformId
      },
      productVisible: false,
      msgVisible: false,
      file: ''
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'MessageNotificationList', title: '通知记录' },
      { name: 'NoticTemplate', title: '通知模板' }
    ]),
      this.uploadFileUrl = this.getAppConfig().serviceUrl + 'inform/sendMessageForm'
  },
  methods: {
    handleChangeFile(info) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = file.response.url
        }
        return file
      })
    },
    beforeUploadFile(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message.warning('上传文件只能是 xls、xlsx格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.warning('上传文件大小不能超过 10MB!')
        return false
      }
      this.fileList = [...this.fileList, file]
      return false
    },
    handleUpload(InformMessageDto) {
      const { fileList } = this
      const formData = new FormData()
      fileList.forEach(file => {
        formData.append('file', file)
      })
      formData.append('mesImgs', this.imageUrl3)
      formData.append('mesIntroduction', this.form.descript)
      formData.append('mesSource', this.form.activity)
      formData.append('mesTitle', this.form.title)
      formData.append('proCatalogId', this.form.proCatalogId)
      formData.append('proCityName', this.form.proCityName)
      formData.append('proId', this.form.proId)
      formData.append('proName', this.form.proName)
      formData.append('mesRecType', this.form.type)
      formData.append('sendScope', this.form.scopeof)
      formData.append('phones', this.form.phones)
      formData.append('platformId', this.platformId)
      formData.append('sendMerchantId', this.merchantId)
      this.getHttpServices()
        .getServerApiService()
        .post('inform/sendMessageForm', formData)
        .then(res => {
          this.msgVisible = false
          this.$message.success('操作成功')
        })
        .catch(err => {
          this.getLogUtils().logWithTag('handleUpload', err)
        })
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(info.fileList)
        // Get this url from response in real world.
        this.imageUrl3 = url
        this.getLogUtils().logWithTag('this.imageUrl3', this.imageUrl3)
      }
    },
    // 发送按钮
    sendbtn() {
      if (!this.form.title) {
        return this.$message.error('请输入标题')
      }
      if (!this.form.descript) {
        return this.$message.error('请输入简介描述')
      }
      if (!this.imageUrl3) {
        return this.$message.error('请上传站内图片')
      }
      if (!this.form.proId && !this.form.proName) {
        return this.$message.error('请选择关联商品')
      }
      let InformMessageDto = {
        // file: this.fileList[0], // 文件
        mesImgs: this.imageUrl3, // 图片
        mesIntroduction: this.form.descript, // 简介
        mesSource: this.form.activity ? this.form.activity : '来自官方活动', // 来源
        mesTitle: this.form.title, // 标题
        proCatalogId: this.form.proCatalogId,
        proCityName: this.form.proCityName,
        proId: this.form.proId,
        proName: this.form.proName,
        mesRecType: this.form.type,
        sendScope: this.form.scopeof,
        phones: this.form.phones,
        platformId: this.platformId,
        sendMerchantId: this.merchantId
      }
      this.getLogUtils().logWithTag('InformMessageDto', InformMessageDto)
      if (this.form.scopeof == 1) {
        this.getHttpServices()
          .getServerApiService()
          .post('inform/sendMessage', InformMessageDto)
          .then(res => {
            this.msgVisible = false
            this.$message.success('操作成功')
          })
          .catch(err => {
            this.getLogUtils().logWithTag('sendbtn', err)
          })
      } else {
        const phoneText = InformMessageDto.phones
        if (!phoneText && this.fileList.length === 0) {
          this.$message.error('请输入接收手机号码或添加附件文件')
        } else if (this.fileList.length > 0) {
          this.handleUpload(InformMessageDto)
        } else if (phoneText) {
          let paramsStr = ''
          const phoneList = phoneText.split('\n')
          InformMessageDto.phones = phoneList.join(',')
          this.getLogUtils().logWithTag('phones', InformMessageDto.phones)
          for (let key in InformMessageDto) {
            if (paramsStr.length > 0) {
              paramsStr = paramsStr + '&'
            }
            paramsStr = paramsStr + key + '=' + InformMessageDto[key]
          }
          let headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
          this.getHttpServices()
            .getServerApiService()
            .post('inform/sendMessageForm', paramsStr, headers)
            .then(res => {
              this.msgVisible = false
              this.form = {
                mesRecType: 1,
                sendScope: 1
              }
              this.imageUrl3 = ''
              this.$message.success('操作成功')
            })
            .catch(err => {
              this.getLogUtils().logWithTag('sendbtn', err)
            })
        }
      }
    },
    getLatestUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        const lastIndex = fileList.length - 1
        if (fileList[lastIndex] && fileList[lastIndex].response) {
          return fileList[lastIndex].response.data
        }
      }
      return ''
    },
    handleCancel() {
      this.visible = false
    },
    msgCancel() {
      this.msgVisible = false
    },
    productCancel() {
      this.productVisible = false
    },
    // 打开商品模态框
    openproductmodal() {
      this.productVisible = true
    },
    downloadTemplateFile() {
      window.open('https://imgb.woyoubooking.com/config/template.xlsx')
    },
    // 选择商品
    selectProduct(item) {
      if (this.visible === true) {
        this.promote.proId = item.proId
        this.promote.productdetail = item.proName
        this.promote.proCityName = item.proCityName
        this.promote.proCatalogId = item.proCatalogId
        this.promote.proNo = item.proNo
        this.promote.proProvinceName = item.proProvinceName
        this.promote.proCatalogName = item.proCatalogName
      }
      if (this.msgVisible === true) {
        this.form.proId = item.proId
        this.form.productdetail = item.proName
        this.form.proCityName = item.proCityName
        this.form.proCatalogId = item.proCatalogId
        this.form.proNo = item.proNo
        this.form.proName = item.proName
        this.form.proProvinceName = item.proProvinceName
        this.form.proCatalogName = item.proCatalogName
      }
      this.productVisible = false
      this.queryProduct.proNo = ''
      this.queryProduct.proName = ''
      this.queryProduct.proId = ''
    },
    // 保存按钮设置
    savesetbtn() {
      this.visible = false
      let InformTreatmentDto = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        proName: this.promote.productdetail || this.promote.proName,
        proCatalogId: this.promote.proCatalogId,
        proCityName: this.promote.proCityName,
        proId: this.promote.proId,
        treatment: this.promote.treatment,
        treatmentId: this.promote.id,
        treatmentStatus: this.promote.treatmentStatus
      }
      this.getHttpServices()
        .getServerApiService()
        .post('inform/addInformTreatment', InformTreatmentDto)
        .then(res => {
          this.$message.success('操作成功')
          this.$refs.table.refresh(true)
        })
        .catch(err => {
          this.getLogUtils().logWithTag('sendbtn', err)
        })
    },
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG) {
        this.$message.error('请选择正确的图片格式上传!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!')
        return false
      }
      return true
    },
    // 推广设置按钮
    promotebtn() {
      let LoginUserDto = {
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      this.getHttpServices()
        .getServerApiService()
        .post('inform/getInformTreatment', LoginUserDto)
        .then(res => {
          this.getLogUtils().logWithTag('==========res==========', res)
          this.promote = res
        })
      this.visible = true
    }
  }
}
</script>
<style scoped>
.avatar {
  position: absolute;
  top: 1px;
  left: 5px;
  right: 1px;
  bottom: 1px;
  height: 101px;
  width: 101px;
}
</style>
